import { render, staticRenderFns } from "./Meeting-role.vue?vue&type=template&id=2a6de4a4"
import script from "./Meeting-role.vue?vue&type=script&lang=js"
export * from "./Meeting-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports